import axios from 'axios';
import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useGlobalStore = defineStore('hcv2-global', () => {

    // Refs initialize
    const initialState = {
        me: {},
        pageHeader: '',
        summary: {},
        rankings: [],
        memberships: [],
        cart: {},
        loading: false,
        asset: '',
        links: {},
        meta: {},
        search: {},
        sortby: [],
        orderby: {},
        global: {
            broadcast: '',
            myid: '',
            timestamp: 0,
            notify: [],
        },
        checked: {},
        notify: [],
        broadcast: {
            private: null,
            public: null,
        },
        is_loading: false,
        is_saving: false,
        //
        timestamp: -1,
        current: null,
        prev: null
    };

    // Refs mapping
    const state = Object.entries(initialState).reduce((acc, [key, value]) => {
        acc[key] = ref(value);
        return acc;
    }, {});

    // Set multiple props
    function setProps(updates) {
        Object.entries(updates).forEach(([key, value]) => {
            if (key in state) {
                state[key].value = value;
            } else {
                console.warn(`未定義的 key: ${key}`);
            }
        });
    }

    // Reset all states
    function reset() {
        Object.entries(initialState).forEach(([key, value]) => {
            state[key].value = value;
        });
    }

    function getRoute(name, params) {
        if ('string' === typeof params) {
            return route(name) + params;
        }
        return route(name, params);
    }

    function getAsset(path) {
        if (!path) {
            return;
        }
        return state['asset'].value.replace('_asset_name_', path);
    }

    const onCartSuccess = (resp) => {
        if (!resp?.data?.data) {
            return;
        }
        state['cart'].value = resp.data.data;
    };
    const onCartFinally = () => {
        state['loading'].value = false;
    };

    // 取得購物車清單
    async function fetchCart() {
        const api = route('hc.api.cart.index');
        state['loading'].value = true;
        await axios.get(api).then(onCartSuccess).finally(onCartFinally);
    };
    // 更新購物車數量
    async function setCartQty(rowId, qty) {
        const api = route('hc.api.cart.update', {cart: rowId});
        state['loading'].value = true;
        await axios.patch(api, { qty }).then(onCartSuccess).finally(onCartFinally);
    }
    //
    async function removeCartItem(rowId) {
        const api = route('hc.api.cart.destroy', {cart: rowId});
        state['loading'].value = true;
        await axios.delete(api).then(onCartSuccess).finally(onCartFinally);
    }

    //
    // const onMemberSuccess = (resp) => {
    //     if (!resp?.data?.data) {
    //         return;
    //     }
    //     state['member'].value = resp.data.data;
    // };
    // const onMemberFinally = () => {
    //     state['loading'].value = false;
    // };
    // async function fetchMember(id) {
    //     const api = route('hc.api.member.show', {user: id});
    //     state['loading'].value = true;
    //     await axios.get(api).then(onMemberSuccess).finally(onMemberFinally);
    // }

    return {
        // 擴充所有狀態
        ...state,
        // 設定多個屬性, 重置所有狀態
        setProps, reset,
        // 取得資產路徑, 取得路由
        getAsset, getRoute,
        // 取得購物車清單, 更新購物車數量, 刪除購物車商品
        fetchCart, setCartQty, removeCartItem,
        // 取得會員資料
        //fetchMember,
    };
});
